import { INVIEW_ENTER } from "@scroll/constants";
import Delay from "@utils/delay";
import { $ } from "@utils/dom";
import { on, off } from "@utils/listener";

const TEXT_SWITCHER_DELAY = 2000;

class TitleReplacements {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.textSwitcher = this.el.classList.contains('--text-switcher') ? new TextSwitcher(this.el, this.emitter) : null;
  }

  destroy() {
    if( this.textSwitcher ) this.textSwitcher.destroy();

    this.el = null;
    this.emitter = null;
    this.textSwitcher = null;
  }
}

class TextSwitcher {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.wrap = $('.title-replacement__wrap', this.el);

    this._delay = null;
    this._index = 0;
    this._length = this.wrap.children.length - 1;
    this._inView = false;
    this._moduleDelay = 0;
    this._tween = null;

    this._onScrollCall = this._onScrollCall.bind(this);
    this._onTimeout = this._onTimeout.bind(this);
    this._onTweenFinish = this._onTweenFinish.bind(this);

    this.init();
  }

  init() {
    this._moduleDelay = parseInt( getComputedStyle(this.el).getPropertyValue('--module-delay') || 0 );
    this._delay = Delay(this._onTimeout, TEXT_SWITCHER_DELAY + this._moduleDelay);

    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    if( this._delay ) this._delay.dispose();
    if( this._tween ) {
      off(this._tween, 'finish', this._onTweenFinish);
      this._tween.cancel();
    }

    this.el = null;
    this.emitter = null;
    this.wrap = null;

    this._delay = null;
    this._index = null;
    this._inView = null;
    this._moduleDelay = null;
    this._tween = null;

    this._onScrollCall = null;
    this._onTimeout = null;
    this._onTweenFinish = null;
  }

  _bindEvents() {
    this.emitter.on('SiteScroll.title-replacement--text-switcher', this._onScrollCall);
  }
  _unbindEvents() {
    this.emitter.off('SiteScroll.title-replacement--text-switcher', this._onScrollCall);
  }
  _resetDelayToDefault() {
    // if delay was increase by module delay, reset it back to original value
    if( this._moduleDelay > 0 ) {
      this._moduleDelay = 0;

      this._delay.dispose();
      this._delay = Delay(this._onTimeout, TEXT_SWITCHER_DELAY);
    }
  }

  _onScrollCall(direction, obj) {
    if( obj.el !== this.el ) return;

    this._inView = direction === INVIEW_ENTER;

    if( this._inView ) {
      // if tween is still running, wait for it to finish before restarting the delay
      if( this._tween ) return;

      this._delay.reset();
      this._delay.start();
    } else {
      this._delay.stop();
      this._resetDelayToDefault();      
    }
  }
  _onTimeout() {
    this._delay.stop();
    this._resetDelayToDefault();

    this._tween = this.wrap.animate({
      transform: [`translateY(${this._index * -1}lh)`, `translateY(${(this._index + 1) * -1}lh)`],
    }, {
      duration: 650,
      fill: 'both', 
      easing: 'cubic-bezier(0.19,1,0.22,1)',
    });

    on(this._tween, 'finish', this._onTweenFinish);
  }
  _onTweenFinish() {
    off(this._tween, 'finish', this._onTweenFinish);

    this._tween = null;
    this._index++;

    if( this._index >= this._length ) this._index = 0;
    if( !this._inView ) return;
    
    this._delay.reset();
    this._delay.start();
  }
}

export default TitleReplacements;
